import { cn as a } from "../../../lib/utils.es.js";
import { Button as u } from "../button/Button.es.js";
import { Input as d } from "../input/Input.es.js";
import { Textarea as p } from "../textarea/Textarea.es.js";
import { jsx as r } from "react/jsx-runtime";
import { cva as b } from "class-variance-authority";
var w = ({ className: l, ...i }) => /* @__PURE__ */ r("div", {
  className: a("lib:group/input-group lib:relative lib:flex lib:h-9 lib:w-full lib:min-w-0 lib:items-center lib:overflow-hidden lib:rounded-lg lib:border lib:border-input lib:bg-white lib:shadow-sm lib:outline-none lib:transition-colors lib:in-data-[slot=combobox-content]:focus-within:border-inherit lib:in-data-[slot=combobox-content]:focus-within:ring-0 lib:has-[>[data-align=block-end]]:h-auto lib:has-[>[data-align=block-start]]:h-auto lib:has-[>textarea]:h-auto lib:has-[>[data-align=block-end]]:flex-col lib:has-[>[data-align=block-start]]:flex-col lib:has-[[data-slot=input-group-control]:focus-visible]:border-ring lib:has-[[data-slot][aria-invalid=true]]:border-destructive lib:has-disabled:bg-input/50 lib:has-disabled:opacity-50 lib:has-[[data-slot=input-group-control]:focus-visible]:ring-3 lib:has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 lib:has-[[data-slot][aria-invalid=true]]:ring-3 lib:has-[[data-slot][aria-invalid=true]]:ring-destructive/20 dark:lib:bg-input/30 dark:lib:has-disabled:bg-input/80 dark:lib:has-[[data-slot][aria-invalid=true]]:ring-destructive/40 lib:has-[>[data-align=block-end]]:[&>input]:pt-3 lib:has-[>[data-align=inline-end]]:[&>input]:pr-1.5 lib:has-[>[data-align=block-start]]:[&>input]:pb-3 lib:has-[>[data-align=inline-start]]:[&>input]:pl-1.5", l),
  "data-slot": "input-group",
  ...i
}), c = b("lib:flex lib:h-auto lib:cursor-text lib:select-none lib:items-center lib:justify-center lib:gap-2 lib:py-1.5 lib:font-medium lib:text-muted-foreground lib:text-sm lib:group-data-[disabled=true]/input-group:opacity-50 lib:[&>kbd]:rounded-[calc(var(--radius)-5px)] lib:[&>svg:not([class*='size-'])]:size-4", {
  defaultVariants: { align: "inline-start" },
  variants: { align: {
    "block-end": "lib:order-last lib:w-full lib:justify-start lib:px-2.5 lib:pb-2 lib:group-has-[>input]/input-group:pb-2 lib:[.border-t]:pt-2",
    "block-start": "lib:order-first lib:w-full lib:justify-start lib:px-2.5 lib:pt-2 lib:group-has-[>input]/input-group:pt-2 lib:[.border-b]:pb-2",
    "inline-end": "lib:order-last lib:pr-2 lib:has-[>button]:mr-[-0.3rem] lib:has-[>kbd]:mr-[-0.15rem]",
    "inline-start": "lib:order-first lib:pl-2 lib:has-[>button]:ml-[-0.3rem] lib:has-[>kbd]:ml-[-0.15rem]"
  } }
}), y = ({ className: l, align: i = "inline-start", ...n }) => /* @__PURE__ */ r("div", {
  className: a(c({ align: i }), l),
  "data-align": i,
  "data-slot": "input-group-addon",
  ...n
}), g = b("lib:flex lib:items-center lib:gap-2 lib:text-sm lib:shadow-none", {
  defaultVariants: { size: "xs" },
  variants: { size: {
    "icon-sm": "lib:size-8 lib:p-0 lib:has-[>svg]:p-0",
    "icon-xs": "lib:size-6 lib:rounded-[calc(var(--radius)-3px)] lib:p-0 lib:has-[>svg]:p-0",
    sm: "",
    xs: "lib:h-6 lib:gap-1 lib:rounded-[calc(var(--radius)-3px)] lib:px-1.5 lib:[&>svg:not([class*='size-'])]:size-3.5"
  } }
}), z = ({ className: l, type: i = "button", variant: n = "ghostPrimary", size: t = "xs", ...o }) => {
  const s = t === "icon-xs" || t === "icon-sm", e = t === "sm" || t === "icon-sm" ? "sm" : "xs";
  return /* @__PURE__ */ r(u, {
    className: a(g({ size: t }), l),
    "data-size": t,
    iconOnly: s,
    size: e,
    type: i,
    variant: n,
    ...o
  });
}, I = ({ className: l, ...i }) => /* @__PURE__ */ r("span", {
  className: a("lib:flex lib:items-center lib:gap-2 lib:text-muted-foreground lib:text-sm lib:[&_svg:not([class*='size-'])]:size-4 lib:[&_svg]:pointer-events-none", l),
  ...i
}), G = ({ className: l, ...i }) => /* @__PURE__ */ r(d, {
  className: a("lib:flex-1 lib:rounded-none lib:border-0 lib:shadow-none lib:ring-0 lib:focus-visible:ring-0 lib:aria-invalid:ring-0", l),
  "data-slot": "input-group-control",
  ...i
}), N = ({ className: l, ...i }) => /* @__PURE__ */ r(p, {
  className: a("lib:flex-1 lib:resize-none lib:rounded-none lib:border-0 lib:py-2 lib:shadow-none lib:ring-0 lib:focus-visible:ring-0 lib:aria-invalid:ring-0", l),
  "data-slot": "input-group-control",
  ...i
});
export {
  w as InputGroup,
  y as InputGroupAddon,
  z as InputGroupButton,
  G as InputGroupInput,
  I as InputGroupText,
  N as InputGroupTextarea
};
